import React from 'react';
import axios from 'helpers/axios';
import { saveAs } from 'file-saver';

export const useBlobDownload = (link) => {
  const [disabled, setDisabled] = React.useState(false);

  const handleClick = async () => {
    if (!link) return;

    setDisabled(true);

    try {
      const response = await axios.get(link, { responseType: 'blob' });
      if (response.status === 200) {
        const filename = response.headers['content-disposition'].match(/filename="(.+)"/)[1];
        saveAs(response.data, filename);
      }
    } catch (e) {
      console.error(e);
    }

    setDisabled(false);
  };

  return {
    onClick: handleClick,
    disabled,
  };
};
